import { Modal } from 'antd'
import React from 'react'

const FutureDateWarningModal = ({ visible, onClose }) => {
    return (
        <div>
            <Modal
                title="Warning"
                open={visible}
                onOk={() => onClose()}
                onCancel={() => onClose()}
                okText="Yes"
                cancelText="No"
            >
                You have selected a future date as Execution Date. Press ‘Yes’ if you
                intend to proceed with the selected future date.
            </Modal>
        </div>
    )
}

export default FutureDateWarningModal